<template>
  <div class="MultipleLine-container">
    <div :ref="chartid" class="chart-div"></div>
  </div>
</template>
<script>
// import { getSize } from '@/utils/utils'
export default {
  name: 'MultipleLine',
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartid: {
      type: String,
      default: 'lineTwoChart'
    }
  },
  data () {
    return {
      peiChar: null,
      name: '',
      seriesData: []
    }
  },
  computed: {},
  created () {
    window.addEventListener('resize', this.chartResize)
  },
  mounted () {
    this.peiChar = this.$echarts.init(this.$refs[this.chartid], null, { renderer: 'svg' })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
  },
  methods: {
    chartResize () {
      if (this.peiChar) {
        setTimeout(() => {
          this.peiChar.resize()
          this.setOptions(this.seriesData, this.name)
        }, 10)
      }
    },
    setOptions(seriesData, name) {
      this.seriesData = seriesData
      this.name = name
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          show: false
        },
        series: [
          {
            name: name,
            type: 'pie',
            radius: '50%',
            data: seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.peiChar.setOption(option, true)
    }
  }
}
</script>
<style scoped lang="scss">
.MultipleLine-container {
  width: 100%;
  height: 100%;
  position: relative;

  .chart-div {
    width: 100%;
    height: 100%;
  }
}
</style>
